<template>
    <div class="list-page">
        <div class="general-title">
            <div class="title"><person-name :model="child" :plural="true"></person-name> Behavior Journal</div>
            <div v-if="!inKidMode" class="buttons-container buttons">
                <a href="/tracker/behaviors/log/create" class="neutral-bg">Make A Journal Entry<span class="fa fa-plus"></span></a>
            </div>
        </div>
        <div class="input-container">
            <div class="input-box"><input type="text" v-model="search" placeholder="Quick Search"><span class="fa fa-search"></span></div>
        </div>
        <div class="list-container">
            <div class="table">
                <div v-if="!!logs.length" class="row">
                    <div class="cell"><a href="" class="point-up">Behavior<span class="fa fa-angles-down"></span></a></div>
                    <div class="cell"><a href="" class="point-down">Journaled</a></div>
                    <div class="cell"><a href="" class="point-down">Result</a></div>
                    <div class="cell align-center"><a href="" class="point-down">Noted</a></div>
                    <div class="cell align-right"></div>
                </div>
                <div v-for="log in logs" :key="`log-${ log.id }`" class="row">
                    <div class="cell"><span class="fa" :class="behaviorIcon(log)"></span> {{ log.behavior }}</div>
                    <div class="cell"><span class="status-bubble" :class="levelClass(log.behavior_level)"><span class="fa"></span>{{ log.behavior_level }}</span></div>
                    <div class="cell"><span class="status-bubble" :class="levelClass(log.new_level)"><span class="fa" :class="arrowClass(log)"></span>{{ log.new_level }}</span></div>
                    <div class="cell align-center"><relative-date :date="log.created_at"></relative-date></div>
                    <div class="cell align-right">
                        <div class="buttons"><a :href="`/tracker/behaviors/log/${ log.id }`" class="neutral-bg">Details<span class="fa fa-search"></span></a></div>
                    </div>
                </div>
                <nothing-here v-if="!logs.length" :is-filtered="search.length > 0"></nothing-here>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LevelsMixin from '@/mixins/LevelsMixin';

export default {

    props: [ 'log' ],

    mixins: [ LevelsMixin ],

    data() {
        return {
            search: '',
        };
    },

    computed: {
        ...mapGetters([ 'child', 'inKidMode' ]),

        logs() {
            if (!this.search || this.search.length === 0) return this.log;

            return this.log.filter(log => {
                return log.description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
            })
        }

    },

    methods: {

        arrowClass(log) {
            if (log.previous_level > log.new_level) {
                return 'fa-arrow-down';
            } else if (log.previous_level < log.new_level) {
                return 'fa-arrow-up';
            }

            return 'fa-arrows-alt-h';
        },

        behaviorIcon(log) {
            switch (log.type) {
                case 'SYSTEM':
                    return 'fa-server';
                case 'LOG':
                default:
                    return 'fa-file-alt';
            }
        },

    },
}

</script>



// WEBPACK FOOTER //
// resources/js/components/tracker/BehaviorLog.vue